<template>
  <v-btn
    v-for="preset in presets"
    :key="preset.label"
    class="ma-1"
    :color="activePreset === preset.label ? 'primary' : ''"
    variant="tonal"
    size="small"
    @click="onSelect(preset)"
  >
    {{ preset.label }}
  </v-btn>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

type Preset = { label: string; range: () => Date[] | null };

export default defineComponent({
  name: 'PresetButtons',
  props: {
    presets: {
      type: Array as PropType<ReadonlyArray<Preset>>,
      required: true,
    },
    activePreset: {
      type: String,
      required: false,
    },
  },
  emits: ['selectPreset'],
  methods: {
    onSelect(preset: Preset) {
      this.$emit('selectPreset', preset);
    },
  },
});
</script>
